import React from "react";
import { Accordion, Container } from "react-bootstrap";
import "../css/Faq.css";

const Faq = () => {
  return (
    <Container fluid className="faq-content">
      <Accordion className="container" defaultActiveKey="0">
        <Accordion.Item className="text-left card-faq" eventKey="0">
          <Accordion.Header className="text-left card-faq-question">
            <b>New!</b>&nbsp;Have you set up your Okta multi-factor
            authentication yet?
          </Accordion.Header>
          <Accordion.Body>
            <p>
              We added Okta multi-factor authentication to your sign-in process
              to give your account an extra layer of security. You should have
              received an email notification from your Box account.
            </p>
            <p>
              <b>No, I need to set up Okta</b>
              <br />
              Follow these steps. Have your mobile device on hand:
            </p>
            <ol>
              <li>
                You should have received an invitation email with the following
                subject line:
                <b>
                  "Action needed - Sign in to your McKinsey Box account now"
                </b>
                . Please check your Spam folder, too. If you don't find it,
                contact your McKinsey engagement team, and they will send it to
                you.
              </li>
              <li>
                Click the <b>unique, one-use activation link</b> provided in the
                email. You'll go to a Box Welcome screen.
              </li>
              <li>
                Create a new password. This password along with your email will
                be your new sign-in credentials for your Box account.
              </li>
              <li>
                Click <b>Create My Account</b>.
              </li>
              <li>
                Follow the steps to choose and set up one of these
                authentication factors:
                <ul>
                  <li>
                    <b>Okta Verify</b>, Okta's mobile app (recommended)
                  </li>
                  <li>SMS message</li>
                  <li>Voice message</li>
                </ul>
              </li>
            </ol>
            <p>Thank you for making your account safer.</p>
            <p>
              <b>Yes, I set up Okta</b>
              <br />
              Go to <b>your new URL</b> &nbsp;
              <a
                href="https://mckinsey-box-cfs.okta.com/"
                rel="noopener noreferrer"
                target="_blank"
                className="highlighted-url"
              >
                https://mckinsey-box-cfs.okta.com&nbsp;
              </a>
              to sign in with your email and new password. Bookmark the link for
              next time.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="text-left card-faq" eventKey="1">
          <Accordion.Header className="text-left card-faq-question">
            I forgot my password.
          </Accordion.Header>
          <Accordion.Body>
            <div>
              Go to &nbsp;
              <b>
                <a
                  href="https://mckidmvp.okta.com/signin/forgot-password"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Forgot password?
                </a>
              </b>
              &nbsp; and follow the steps.
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="text-left card-faq" eventKey="2">
          <Accordion.Header className="text-left card-faq-question">
            My Okta verification code expired.
          </Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Make sure your token is still valid. <b>Okta Verify</b>&nbsp;
                generates a new token every 30 seconds.
              </li>
              <li>
                Try to click <b>Send push</b>, and approve the access in the
                &nbsp;<b>Okta Verify</b> application.
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="text-left card-faq" eventKey="3">
          <Accordion.Header className="text-left card-faq-question">
            I didn't receive my Okta SMS verfication.
          </Accordion.Header>
          <Accordion.Body>
            Verify that the phone number you entered is correct and click&nbsp;
            <b>Send code</b>.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item className="text-left card-faq" eventKey="4">
          <Accordion.Header className="text-left card-faq-question">
            I didn't get my Okta voice message verification.
          </Accordion.Header>
          <Accordion.Body>
            Verify that the phone number you entered is correct and click&nbsp;
            <b>Call</b>.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default Faq;
